import { render, staticRenderFns } from "./ChildBirthCert.vue?vue&type=template&id=1b8e9295&"
import script from "./ChildBirthCert.vue?vue&type=script&lang=js&"
export * from "./ChildBirthCert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports